import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import CargomaticModal from '../../../v2/modal';

export default function BulkApprovalModal({
  showModal,
  selectedRates,
  onSave,
  onClose,
}) {
  const { t } = useTranslation();
  const ccbatEnabled = featureEnabled(CONFIGURED_FEATURES.CCBAT);

  function getBody() {
    return (
      <div data-testid="div-02be5528" className="block">
        <div data-testid="div-1bf3a390" className="pb-4 text-sm">
          <b data-testid="b-5deab6f1">{t('BULK_APPROVE_INFO_HEADER_TEXT')}</b>
        </div>
        <div data-testid="div-7416ab4c" className="max-h-56 overflow-y-auto">
          <table data-testid="table-f9c51bd2" className="default-table">
            <thead data-testid="thead-4d2caf02">
              <tr data-testid="tr-1510bf73">
                <th data-testid="th-f499b094">{t('SHIPMENT_COUNT')}</th>
                <th data-testid="th-05a7b333">{t('CARRIER_RATE')}</th>
                {ccbatEnabled && (
                  <>
                    <th data-testid="th-951bd5ca">{t('CARRIER_FSC')}</th>
                    <th data-testid="th-6d8fd943">{t('TOTAL')}</th>
                  </>
                )}
                <th data-testid="th-afab4baa">{t('ORIGIN')}</th>
                <th data-testid="th-85c7d7bd">{t('DESTINATION')}</th>
              </tr>
            </thead>
            <tbody data-testid="tbody-2fcd746a">
              {selectedRates.map((rates, index) => (
                <tr data-testid={`tr-9fe0a2be-${index}`} key={index}>
                  <td data-testid={`td-414d30da-${index}`}>{rates.count}</td>
                  <td data-testid={`td-74013e4c-${index}`}>
                    {formatMoney(rates.carrier_base_cost, rates?.currency)}
                  </td>
                  {ccbatEnabled && (
                    <>
                      <td data-testid={`td-d90e4aff-${index}`}>
                        {rates?.carrierFscTotal
                          ? formatMoney(rates?.carrierFscTotal, rates?.currency)
                          : '-'}
                      </td>
                      <td data-testid={`td-d0d56d83-${index}`}>
                        {rates?.carrierFscTotal
                          ? formatMoney(
                              rates.carrierFscTotal + rates.carrier_base_cost,
                              rates?.currency,
                            )
                          : formatMoney(
                              rates.carrier_base_cost,
                              rates?.currency,
                            )}
                      </td>
                    </>
                  )}
                  <td data-testid={`td-2e1a2f1a-${index}`}>
                    {rates.originAddress}
                  </td>
                  <td data-testid={`td-69f38451-${index}`}>
                    {rates.destinationAddress}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  function getFooter() {
    return (
      <div data-testid="div-9b782dc4">
        <button
          data-testid="button-20b440ca"
          className="button button-secondary"
          type="button"
          onClick={onClose}
        >
          {t('NO')}
        </button>
        <button
          data-testid="button-d3b2d24f"
          className="button button-green"
          onClick={onSave}
        >
          {t('YES')}
        </button>
      </div>
    );
  }

  return (
    <CargomaticModal
      dataTestId="CargomaticModal-b264325c"
      title={t('ARE_YOU_SURE')}
      style={{ top: '20%' }}
      showCloseButton={false}
      show={showModal}
      onHide={onClose}
      body={getBody()}
      footer={getFooter()}
    />
  );
}

BulkApprovalModal.propTypes = {
  showModal: PropTypes.bool,
  selectedRates: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
